import Dots from './Dots';
import localizableStrings from './localizableStrings'
const WhenAndWhere = (props) =>{
    return(
        <div className="flexRow whenAndWhereContainer">
            <Dots/>
            <div className="flexColumn whenAndWhereText">
                <div className="flexRow">{localizableStrings[props.locale].when}: <div style={{fontWeight:'bold'}}>{localizableStrings[props.locale].eventDate}</div></div>
                <div className="flexRow">{localizableStrings[props.locale].location}: <div style={{fontWeight:'bold'}}>{localizableStrings[props.locale].eventLocation}</div></div>
            </div>
        </div>
    )
}

export default WhenAndWhere;